import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { CategoryRequest, CategoriesService } from '@src/app/shared/backend/clients';
import { ComboData } from '@src/app/shared/components/comboData/comboData';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-add-category',
    templateUrl: './add-category.component.html',
    styleUrl: './add-category.component.scss',
    host: {
        class: 'app-add-category'
    },
    standalone: false
})
export class AddCategoryComponent extends BaseViewComponent implements OnInit {

  comboData: ComboData = new ComboData(async (filter) => await firstValueFrom(this.categoriesService.apiCategoriesFilterComboPost(filter)));

  public categoryForm: FormGroup = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    code: ['', [Validators.required, Validators.maxLength(50)]],
    hasParentCategory: ['false'],
    parentCategoryId: [[]]
  },
    { validators: this.conditionalValidators() });

  constructor(
    private router: Router,
    private categoriesService: CategoriesService,
    private fb: FormBuilder
  ) { super(); }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    await this.initComboData();
  }

  private async initComboData() {
    await this.comboData.getData(null, 1);
  }

  async onLazyLoadComboData(event: any) {
    const search = event?.search?.trim() || null;
    const activePage = Math.max(1, (event?.pageIndex ?? 1));

    await this.comboData.getData(search, activePage);
  }

  getComboTotalPages(): number {
    const totalRecords = this.comboData?.totalRecords ?? 0;
    const pageSize = Number(this.comboData?.rowsPerPageOption) || 5;

    return Math.max(1, Math.ceil(totalRecords / pageSize));
  }

  conditionalValidators(): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: any } | null => {
      const hasParentCategory = formGroup.get('hasParentCategory')?.value;
      const category = formGroup.get('parentCategoryId')?.value ?? [];

      if (hasParentCategory === 'true' && category.length === 0) {
        return { requiredCategory: true };
      }

      return null;
    };
  }

  isCategoryRequired(): boolean {
    return this.categoryForm.get('hasParentCategory')?.value === 'true';
  }

  async submitForm() {
    if (this.categoryForm.valid) {
      const payload: CategoryRequest = {
        name: this.categoryForm.controls['name'].value,
        code: this.categoryForm.controls['code'].value,
        parentId: this.categoryForm.controls['parentCategoryId'].value?.[0]
      };

      await firstValueFrom(this.categoriesService.apiCategoriesCreatePost(payload));

      this.categoryForm.controls['name'].setValue(null);
      this.categoryForm.controls['code'].setValue(null);
      this.categoryForm.controls['parentCategoryId'].setValue([]);

      this.router.navigate(['/categories']);
    }
  }
}
